import { z } from 'zod'
import type { Hex } from '../../types'
import type { Contract } from '../types'
import type { BlockscoutClient } from './client'

type GetContractSourceCodeForAVerifiedContractParameters = {
  client: BlockscoutClient
  address: Hex
  headers?: Record<string, string>
}

const resultSchema = z.array(
  z.object({
    ABI: z.string().optional(),
    ContractName: z.string().optional(),
  }),
)

/** {@link https://docs.blockscout.com/developer-support/api/rpc-endpoints/contract#get-contract-source-code-for-a-verified-contract} */
export const getContractSourceCodeForAVerifiedContract = async ({
  client,
  address,
  headers,
}: GetContractSourceCodeForAVerifiedContractParameters): Promise<
  Contract | undefined
> => {
  const result = await client.get({
    path: '',
    query: {
      module: 'contract',
      action: 'getsourcecode',
      address,
    },
    resultSchema,
    headers,
  })
  if (result.length === 0) {
    return undefined
  }
  const contract = result[0]
  if (
    contract.ABI === undefined ||
    contract.ABI.length === 0 ||
    contract.ContractName === undefined ||
    contract.ContractName.length === 0
  ) {
    return undefined
  }

  return {
    abi: contract.ABI,
    name: contract.ContractName,
  }
}
